<template>
	<div>
		<div class="text-center mt-2">
			<label>
				<gmap-autocomplete
					@place_changed="setPlace"
					style="border:1px solid black;padding: 4px;width:80%"
				>
				</gmap-autocomplete>
				<button
					@click="addMarker"
					style="border:1px solid black; margin-left: 5px;padding: 4px;background-color: #2185d0;"
				>
					Add
				</button>
			</label>
			<br />
		</div>
		<br />
		<gmap-map
			:center="center"
			:zoom="12"
			style="width: 100%; height: 400px"
			@click="onMapClick"
			:options="{
				streetViewControl: false
			}"
		>
			<gmap-marker :position="marker.position"></gmap-marker>
		</gmap-map>
		<div v-if="isLoading" class="overlay">
			<v-progress-circular :indeterminate="true"></v-progress-circular>
		</div>
		<v-dialog v-model="showPopup" persistent max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Allow Location Access</span>
				</v-card-title>
				<div class="text-xs-center" style="font-size:large;">
					Please enable location access or choose location manually
				</div>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="error" flat @click="showPopup = false"
						>Close</v-btn
					>
				</v-card-actions>
			</v-card></v-dialog
		>
	</div>
</template>

<script>
import ApiService from "@/store/api-service";
import { GOOGLE_API_KEY } from "../../config";

export default {
	name: "GoogleMap",
	data() {
		return {
			center: { lat: 12.9715987, lng: 77.5945627 },
			marker: { position: { lat: 12.9715987, lng: 77.5945627 } },
			places: [],
			currentPlace: null,
			isLoading: false,
			showPopup: false,
			locationInfo: {
				state: "",
				city: "",
				postalCode: "",
				address: "",
				lat: "",
				lng: ""
			}
		};
	},

	mounted() {
		this.geolocate();
		window.addEventListener("message", this.onMessageHandler);
	},
	beforeUnmount() {
		window.removeEventListener("message", this.onMessageHandler);
	},
	methods: {
		setPlace(place) {
			this.currentPlace = place;
		},
		addMarker() {
			if (this.currentPlace) {
				const newMarker = {
					lat: this.currentPlace.geometry.location.lat(),
					lng: this.currentPlace.geometry.location.lng()
				};
				this.marker = { position: newMarker };
				this.places.push(this.currentPlace);
				this.center = newMarker;
				this.currentPlace = null;
				this.getLocationInfo();
			}
		},
		onMapClick(e) {
			const newMarker = { lat: e.latLng.lat(), lng: e.latLng.lng() };
			this.center = newMarker;
			this.marker = { position: newMarker };
			this.getLocationInfo();
		},
		geolocate() {
			if (window.ReactNativeWebView) {
				window.ReactNativeWebView.postMessage(
					JSON.stringify({
						fetchLocation: true
					})
				);
				this.isLoading = true;
			} else {
				navigator.permissions
					.query({ name: "geolocation" })
					.then(result => {
						if (result.state === "granted") {
							this.setCurrentLocation();
						} else {
							this.showPopup = true;
						}
						result.onchange = () => {
							if (result.state === "granted") {
								this.setCurrentLocation();
							}
						};
					});
			}
		},
		setCurrentLocation() {
			this.isLoading = true;
			navigator.geolocation.getCurrentPosition(position => {
				this.center = {
					lat: position.coords.latitude,
					lng: position.coords.longitude
				};
				this.isLoading = false;
				this.marker = { position: { ...this.center } };
				this.getLocationInfo();
			});
		},
		async getLocationInfo() {
			try {
				const endpoint = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${this.center.lat},${this.center.lng}&key=${GOOGLE_API_KEY}`;
				const response = await ApiService.get(endpoint);
				(response.results[0].address_components || []).map(item => {
					if (item.types[0] === "postal_code")
						this.locationInfo.postalCode = item.long_name;
					else if (item.types[0] === "administrative_area_level_1")
						this.locationInfo.state = item.long_name;
					else if (item.types[0] === "locality")
						this.locationInfo.city = item.long_name;
				});
				this.locationInfo.address =
					response.results[0].formatted_address;
				this.locationInfo.lat = this.center.lat;
				this.locationInfo.lng = this.center.lng;
				this.$emit("GET_LOCATION_INFO", this.locationInfo);
			} catch (e) {
				console.log("err", e);
			}
		},
		onMessageHandler(e) {
			const { data } = e;
			try {
				const { type, payload } = data;
				const { latitude, longitude } = payload;
				if (type === "LOCATION") {
					if (latitude !== "FAILED" && latitude !== "NO_PERMISSION") {
						this.center = {
							lat: latitude,
							lng: longitude
						};
						this.marker = { position: { ...this.center } };
						this.getLocationInfo();
					} else {
						this.showPopup = true;
					}
				}
			} catch (error) {
				console.log("error: ", error);
			} finally {
				this.isLoading = false;
			}
		}
	}
};
</script>
